export default __webpack_public_path__ + "static/media/logout.943a2c9a.svg";